export default __webpack_public_path__ + "static/Inter-Bold-ec64ea577b0349e055ad6646c1d8797a.woff2";